module.exports = __webpack_public_path__ + "static/media/25UNHCR1.8bc05b5d.jpg";